module.exports = __webpack_public_path__ + "img/ic_notification_premium.d0e6f048.svg";